import costMeritsConfig from 'wwg-utilities/dist/config/costMeritsConfig';
import project from './project';
const costMeritsIconMapping = costMeritsConfig[project].costMeritsIconsMapping;
export default costMeritsIconMapping;
